let videomodal = null;
let pushed = null;

export default {

	setVideoModal(value) {
		videomodal = value;
	},
	getVideoModal() {
		return videomodal;
	},

	setPushed(value) {
		pushed = value;
	},
	getPushed() {
		return pushed;
	}

}